import { Component, OnInit } from '@angular/core';
import { EmpNumberChangeRequestDto } from 'src/app/models/EmpNumberChangeRequestDto';
import { ContractsService } from 'src/app/services/contracts.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationType } from 'src/app/models/notification.message';
import { LoginResponseData } from 'src/app/models/responses/login-response-data';
import { TokenService } from 'src/app/services/token.service';
import { ContractRenewalRequestDto } from 'src/app/models/ContractRenewalRequestDto';
import { ExitDateRequestDto } from 'src/app/models/ExitDateRequestDto';
import { EmployeesService } from 'src/app/services/employees.service';
@Component({
  selector: 'app-changeemp',
  templateUrl: './changeemp.component.html',
  styleUrls: ['./changeemp.component.css']
})
export class ChangeempComponent implements OnInit {

  constructor(private employeesService: EmployeesService ,   private tokenService: TokenService,   public msg: NzMessageService, private contractService:ContractsService,  private notification: NotificationService ) { }
  
  Requests:EmpNumberChangeRequestDto[]=[];
  ExitRequests: ExitDateRequestDto[]=[];
  loading = false;
  ApprovalMessage:string ="";
  RejectionMessage:string ="";
  isChangeOkLoading = false;
  isChangeLoading= false;
  isApprovalModalVisible = false;
  isRejectionModalVisible= false;
  id:number=0;
  isRenewalApprovalModalVisible:boolean=false;
  RenewalApprovalComment:string="";
  isRenewalRejectionModalVisible:boolean=false;
  RenewalRequests:ContractRenewalRequestDto[]=[];
  RenewalRejectionMessage:string="";
  isExitApprovalModalVisible:boolean=false;
  ExitApprovalComment:string='';
  ExitRejectionMessage:string='';

  isExitRejectionModalVisible:boolean=false;
  spacesize: 'small' | 'middle' | 'large' | number = 'small';
  noResult:string='You have no pending request';
  ngOnInit(): void {
    this.LoadRequests();
    this.loading = true ;
    this.loading = false ;
  }
async LoadRequests()
{
  const loginResponse: LoginResponseData = this.tokenService.getInfo();
  let id:number = loginResponse.profile.designationId;
  
  let resEmployees = await this.contractService.GetPendingEmpChangeRequest().toPromise();
  this.Requests = <EmpNumberChangeRequestDto[]>resEmployees.responseData;


  let renRequest = await this.contractService.getMyPendingRenewalToApprove().toPromise();
  this.RenewalRequests = <ContractRenewalRequestDto[]>renRequest.responseData;

  
  let exitRequest = await this.employeesService.getPendingExitRequests().toPromise();
  this.ExitRequests = <ExitDateRequestDto[]>exitRequest.responseData;
   


}

handleCancel(): void {
 this.isRejectionModalVisible=false;
  this.isApprovalModalVisible = false;
  this.isRenewalApprovalModalVisible=false;
  this.isRenewalRejectionModalVisible=false;
 this.isExitApprovalModalVisible = false;
}
sendApproval()
{
  
    this.isChangeOkLoading = true;
    let data = { id: this.id, message: this.ApprovalMessage, token:''}
    this.contractService.approveEmpChange(data).subscribe({
      next: (data => {

        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: `Request approved successfully `,
            type: NotificationType.success
          });

          this.isApprovalModalVisible = false;

         // this.close();
          this.LoadRequests();

          this.isChangeOkLoading = false;
        }
        else {
          this.isChangeOkLoading = false;
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
          this.isChangeOkLoading = false;
        }

      }),
      error: ((error: any) => {
        this.notification.sendMessage({
          message: error.message,
          type: NotificationType.error
        });
        this.isChangeOkLoading = false;
      })

    });
  

}
sendRejection()
{
  if (this.RejectionMessage === '') {
    this.notification.sendMessage({
      message: 'Comment is required',
      type: NotificationType.error
    });
  }
  else {
    this.isChangeLoading = true;
    let data = { id: this.id, message: this.RejectionMessage,token:'' }
    this.contractService.rejectEmpChange(data).subscribe({
      next: (data => {

        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: `Request sent successfully `,
            type: NotificationType.success
          });

          this.isRejectionModalVisible = false;
          this.ApprovalMessage='';
          this.RejectionMessage='';
         // this.close();
          this.LoadRequests();

          this.isChangeLoading = false;
        }
        else {
          this.isChangeOkLoading = false;
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
          this.isChangeLoading = false;
        }

      }),
      error: ((error: any) => {
        this.notification.sendMessage({
          message: error.message,
          type: NotificationType.error
        });
        this.isChangeLoading = false;
      })

    });
  }

}


sendRenewalApproval()
{

  this.isChangeOkLoading = true;
    let data = { id: this.id, message: this.RenewalApprovalComment,token:'' }
    this.contractService.approveRenewal(data).subscribe({
      next: (data => {

        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: `Request approved successfully `,
            type: NotificationType.success
          });

          this.isRenewalApprovalModalVisible = false;

         // this.close();
          this.LoadRequests();

          this.isChangeOkLoading = false;
        }
        else {
          this.isChangeOkLoading = false;
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
          this.isChangeOkLoading = false;
        }

      }),
      error: ((error: any) => {
        this.notification.sendMessage({
          message: error.message,
          type: NotificationType.error
        });
        this.isChangeOkLoading = false;
      })

    });
  



}

sendRenewalRejection()
{
  if (this.RejectionMessage === '') {
    this.notification.sendMessage({
      message: 'Comment is required',
      type: NotificationType.error
    });
  }
  else {
    this.isChangeLoading = true;
    let data = { id: this.id, message: this.RenewalRejectionMessage,token:'' }
    this.contractService.rejectRenewal(data).subscribe({
      next: (data => {

        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: `Request sent successfully `,
            type: NotificationType.success
          });

          this.isRenewalRejectionModalVisible = false;
          this.RenewalRejectionMessage='';
          this.RenewalRejectionMessage='';
         // this.close();
          this.LoadRequests();

          this.isChangeLoading = false;
        }
        else {
          this.isChangeOkLoading = false;
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
          this.isChangeLoading = false;
        }

      }),
      error: ((error: any) => {
        this.notification.sendMessage({
          message: error.message,
          type: NotificationType.error
        });
        this.isChangeLoading = false;
      })

    });
  }

}

 
sendExitApproval()
{

  this.isChangeOkLoading = true;
    let data = { id: this.id, message: this.ExitApprovalComment , token:''}
    this.employeesService.ApproveEmpExitDateChange(data).subscribe({
      next: (data => {

        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: `Request approved successfully `,
            type: NotificationType.success
          });

          this.isExitApprovalModalVisible = false;

         // this.close();
          this.LoadRequests();

          this.isChangeOkLoading = false;
        }
        else {
          this.isChangeOkLoading = false;
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
          this.isChangeOkLoading = false;
        }

      }),
      error: ((error: any) => {
        this.notification.sendMessage({
          message: error.message,
          type: NotificationType.error
        });
        this.isChangeOkLoading = false;
      })

    });
  



}
sendExitRejection()
{
  if (this.ExitRejectionMessage === '') {
    this.notification.sendMessage({
      message: 'Comment is required',
      type: NotificationType.error
    });
  }
  else {
    this.isChangeLoading = true;
    let data = { id: this.id, message: this.ExitRejectionMessage,token:'' }
    this.employeesService.RejectEmpExitDateChange(data).subscribe({
      next: (data => {

        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: `Request sent successfully `,
            type: NotificationType.success
          });

          this.isExitRejectionModalVisible = false;
          
          this.ExitRejectionMessage='';
         // this.close();
          this.LoadRequests();

          this.isChangeLoading = false;
        }
        else {
          this.isChangeOkLoading = false;
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
          this.isChangeLoading = false;
        }

      }),
      error: ((error: any) => {
        this.notification.sendMessage({
          message: error.message,
          type: NotificationType.error
        });
        this.isChangeLoading = false;
      })

    });
  }

}

openApprovalModal(id: number) {
 
  this.id=id;
  this.isApprovalModalVisible = true;
}
openRenewalApprovalModal(id: number) {
 
  this.id=id;
  this.isRenewalApprovalModalVisible = true;
}

openExitApprovalModal(id: number) {
 
  this.id=id;
  this.isExitApprovalModalVisible = true;
}





openRejectionModal(id: number) {
 
  this.id=id;
  this.isRejectionModalVisible = true;
}
openRenewalRejectionModal(id: number) {
 
  this.id=id;
  this.isRenewalRejectionModalVisible = true;
}


openExitRejectionModal(id: number) {
 
  this.id=id;
  this.isExitRejectionModalVisible = true;
}



cancel(): void {
  return;
}

}
